/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAccessorMore = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m18.293 7.293 1.414 1.414L17.414 11H22v2h-4.586l2.293 2.293-1.414 1.414L14.585 13H10v-2h4.585zM5 9a3 3 0 1 1-.001 6.001A3 3 0 0 1 5 9zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 11z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAccessorMore as AccessorMore };
